<template>
    <div class="af" >
        <div class="flex alc" id="toolH">
            <!--<el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    clearable
                    type="daterange"
                    :range-separator="$t('form_to')"
                    :start-placeholder="$t('form_start_date')"
                    :end-placeholder="$t('form_end_date')">
            </el-date-picker>-->
            <el-input  class="marr4" style="width: 195px"  v-model="vc_search" :placeholder="$t('invoiceEntry_please_enter_the_batch_number/product_name_to_search')" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <span class="marr4">{{$t('invoiceEntry_total_invoice_amount')+fppay}}</span>
            <span class="marr4">{{$t('invoiceEntry_remaining_total_amount')+remainingAmount}}</span>
        </div>
        <el-table
                v-loading="loading"
                v-if="showTable"
                border
                :data="tableData"
                class="el-child-table marT10"
                ref="table"
                size="mini"
                :height="tableHeight"
                style="width: 100%"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                @select="select"
                @selection-change="handleSelectionChange"
                :row-key="row => row.i_pzid"
                :default-selection="defaultSelectedRows"
                show-summary
                :summary-method="getSummaries"
        >
            <el-table-column
                    align="center"
                    type="selection"
                    :selectable="checkSelectable"
                    :reserve-selection="true"
                    width="50">
            </el-table-column>
            <el-table-column
                    type="index"
                    label=""
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="i_pzid"
                    :label="$t('invoiceEntry_cost_id')"
                    show-overflow-tooltip
                    width="70">
            </el-table-column>
            <el-table-column
                    prop="vc_no"
                    :label="$t('form_order_number')"
                    show-overflow-tooltip
                    min-width="130">
            </el-table-column>
            <el-table-column
                    prop="vc_xcode"
                    :label="$t('invoiceEntry_sales_order_number')"
                    show-overflow-tooltip
                    min-width="130">
            </el-table-column>-->
            <!--<el-table-column
                    prop="vc_code"
                    :label="$t('invoiceEntry_document_number')"
                    show-overflow-tooltip
                    min-width="130">
            </el-table-column>-->
            <el-table-column
                    prop="vc_pzname"
                    :label="$t('form_product_name')"
                    show-overflow-tooltip
                    min-width="110">
                <template slot-scope="scope">
                    <span>{{scope.row.vc_pzname}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    align="right"
                    prop="f_fynum"
                    :label="$t('invoiceEntry_quantity_of_expenses')"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    align="right"
                    prop="f_yfee_yj"
                    :label="$t('invoiceEntry_estimated_amount')"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    align="right"
                    prop="f_fyje"
                    :label="$t('invoiceEntry_amount_of_fee')"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    align="right"
                    prop="f_kglfpnum"
                    label="可关联发票数量"
                    show-overflow-tooltip>
            </el-table-column>-->
            <!--<el-table-column
                    align="right"
                    prop="f_kglfpje"
                    :label="$t('invoiceEntry_can_be_associated_with_invoice_amount')"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    align="right"
                    prop="f_je"
                    :label="$t('invoiceEntry_this_associated_invoice_amount')"
                    show-overflow-tooltip
                    min-width="130">
                <!--<template slot-scope="scope">
                    <el-input-number @change="inbcfnum(tableData,scope.$index,scope.row)"  :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_je" ></el-input-number>
                </template>-->
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_je_ws"
                    :label="$t('invoiceEntry_tax-excluded_amount_on_the_invoice')"
                    show-overflow-tooltip
                    width="130">
                <!--<template slot-scope="scope">
                    <el-input-number @change="inpayws(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_je_ws" ></el-input-number>
                </template>-->
                <template slot-scope="scope">
                    <el-input-number @change="inbcfnum(tableData,scope.$index,scope.row)"  :controls="false" :precision="$setPrecision.quantityPrecision" size="mini" v-model="scope.row.f_je_ws" ></el-input-number>
                </template>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_sl"
                    :label="$t('form_tax_rate')"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    align="right"
                    prop="f_je_zzs"
                    :label="$t('invoiceEntry_tax_amount')"
                    show-overflow-tooltip
                    width="130">
                <template slot-scope="scope">
                    <el-input-number @change="inpayzzs(tableData,scope.$index,scope.row)"  :controls="false" :precision="2" size="mini" v-model="scope.row.f_je_zzs" ></el-input-number>
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="dt_createtime"
                    :label="$t('form_creation_time')"
                    show-overflow-tooltip
                    min-width="110">
            </el-table-column>-->
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[500, 1000, 2000]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div slot="footer" class="dialog-footer" style="text-align: center;padding: 6px">
            <el-button  type="primary" @click="confirm"  :class="baseerp+'btn'" size="small">{{$t('button_confirm')}}</el-button>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>

    </div>
</template>
<script>
    import * as API from "./api"
    import {baseerp} from "@/utils/baseUrl";
    export default {
        name: "",
        components: {

        },
        props: {
            dataOrd: {
                type: Object,
                required: true,
            },
            dataZt: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                remain:0,
                totalje:0,
                fppay:0,
                dialogVisible:false,
                tableHeight: 400,
                loading:false,
                dt_startdate:'',
                dt_enddate:'',
                vc_search:"",
                valuetime:'',
                baseerp: "",
                mid: 0,
                expend:false,
                showTable:true,
                tableData: [],
                multipleSelection: [],
                pageSize: 500,
                currentPage: 1,
                tableTotal: 0,
                highlightCurrentRow: false,
                currentInvoiceId: null,
                selectedPid: null,
                form:{},
                i_isfrom:null,
                i_checkstate:0,
                dataList: [],  // 用于展示的原始数据列表
                deletedIds: [],    // 用来存储被删除的数据ID
                masterSelectedList:[],
            }
        },
        updated() {
            if(this.$refs.table && this.$refs.table.doLayout){
                this.$refs['table'].doLayout();
            }

        },
        computed: {
            defaultSelectedRows() {
                // 返回当前选中的数据用于 default-selection
                return this.masterSelectedList;
            },
            remainingAmount() {
                //console.log('this.remain',this.remain)
                //console.log('this.totalje',this.totalje)
                //console.log(this.remain - this.totalje)
                return this.keepTwoDecimal(this.remain - this.totalje)

            },

        },
        created() {
            const listFromA = this.dataZt.select;
            if (listFromA && Array.isArray(listFromA)) {
                this.initMasterSelected(listFromA)
            }
        },
        mounted() {
            //this.getfMou();
            //console.log("sessionStorage.getItem('mids')",sessionStorage.getItem('mids'))
            //console.log("dataOrd", this.dataOrd);
            //console.log("dataZt", this.dataZt);
            //this.remain=this.dataZt.remain;
            //console.log("remainingAmount", this.remainingAmount);
            this.dataList=this.dataZt.select;
            this.form=this.dataOrd.row;
            this.i_isfrom=this.dataOrd.i_isfrom;
            //this.currentInvoiceId = this.dataOrd.index;
            this.currentInvoiceId = this.dataOrd.row.localId;
            this.i_checkstate=this.dataOrd.i_checkstate;
            this.fppay=Number((this.dataOrd.row.f_pay_ws+this.dataOrd.row.f_pay_zzs).toFixed(2));
            //console.log(this.fppay,'this.fppay')
            this.getOrders();
            this.baseerp = baseerp;

        },
        beforeDestroy() {
            window.removeEventListener('resize', this.updateTableHeight);
        },
        methods: {
            updateTableHeight() {
                //console.log(this.dataOrd.maxDialogHeight,'this.dataOrd.maxDialogHeight');
                const dialogHeight = this.dataOrd.maxDialogHeight ; // 弹窗最大高度
                //console.log(dialogHeight,' dialogHeight');
                const otherHeight = 415;
                this.tableHeight = dialogHeight - otherHeight;
                //console.log( this.tableHeight,' this.tableHeight')
                this.maxDialogHeight=dialogHeight;
            },
            initMasterSelected(list) {
                list.forEach(item => {
                    if (!this.masterSelectedList.find(i => i.i_pzid === item.i_pzid)) {
                        this.masterSelectedList.push(item)   // 存完整对象
                    }
                })
                this.masterSelectedList.forEach(row => {
                    this.dataZt.remain += Number(row.f_je) || 0;
                });
                this.remain=this.dataZt.remain;
                //console.log("remain",this.remain);
                //console.log("masterSelectedList",this.masterSelectedList);
            },
            //除
            preciseDiv(dividend, divisor) {
                if(dividend&&divisor){
                    //console.log(dividend,"////",divisor);
                    // 将除数和被除数转换为整数
                    const intDividend = parseFloat(dividend * 1000);
                    const intDivisor = parseFloat(divisor * 1000);
                    // 执行除法
                    const result = intDividend / intDivisor;
                    //console.log(result,'result------')
                    return result ;
                }
            },
            inbcfnum(data,index,row){
                //console.log('row',row)
                if(row.f_je_ws > 0){
                    row.f_je_ws = 0;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_associated_amount_cannot_be_a_positive_number'));
                    this.refreshTable();
                    //return;
                }
                let payzzs = row.f_je_ws*row.f_sl;
                row.f_je_zzs = parseFloat(this.keepTwoDecimal(payzzs));
                let je = row.f_je_ws+payzzs;
                row.f_je = parseFloat(this.keepTwoDecimal(je));

                /*if(row.f_je < row.f_kglfpje){
                    row.f_je = row.f_kglfpje;
                    this.$set(data,index,row);
                    this.$message.error(this.$t('invoiceEntry_the_amount_of_this_associated_invoice_cannot_exceed_the_amount_of_the_invoice_that_can_be_associated'));
                    this.refreshTable();
                    return;
                }*/
                this.$set(data,index,row);
                const idx = this.masterSelectedList.findIndex(item => item.i_pzid === row.i_pzid);
                if (idx >= 0) this.$set(this.masterSelectedList, idx, { ...row });
                this.changeselT();
                //console.log(row,'row--')
            },
            /*inpayws(data,index,row){
                let cenzzs = row.f_currentrelated_num * row.f_price_ws;
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                //console.log(cenzzs,'cenzzs')
                let more = cenzzs+1;
                let less = cenzzs-1;
                //console.log(more,'more')
                //console.log(less,'less')
                //this.dataOrd.row.f_fpnum>0&&
                if((row.f_je_ws<less||row.f_je_ws>more)){
                    this.$nextTick(()=>{
                        row.f_je_ws = cenzzs;
                    })
                    this.$message.error(this.$t('invoiceEntry_the_tax-free_price_must_not_exceed_or_fall_short_of_the_set_price_by_more_than')+cenzzs+"±1！！");
                    this.$set(data,index,row);
                    return
                }
                let fzzs = row.f_je_ws * row.f_sl;
                fzzs = parseFloat(this.keepTwoDecimal(fzzs));
                row.f_je_zzs = fzzs;
                this.$set(data,index,row);
                //this.changeselT()
                const idx = this.masterSelectedList.findIndex(item => item.i_pzid === row.i_pzid);
                if (idx >= 0) this.$set(this.masterSelectedList, idx, { ...row });
            },*/
            inpayzzs(data,index,row){
                let cenzzs = row.f_je_ws * row.f_sl;
                cenzzs = parseFloat(this.keepTwoDecimal(cenzzs));
                //console.log(cenzzs,'cenzzs')
                let more = cenzzs+1;
                let less = cenzzs-1;
                //console.log(more,'more')
                //console.log(less,'less')
                //this.dataOrd.row.f_fpnum>0&&
                if((row.f_je_zzs<less||row.f_je_zzs>more)){
                    this.$message.error(this.$t('invoiceEntry_the_tax_amount_must_not_exceed_or_be_less_than_the_established_tax_amount_by_more_than')+cenzzs+"±1！");
                    //this.$nextTick(()=>{
                        row.f_je_zzs = cenzzs;
                        //let je = row.f_je_ws+row.f_je_zzs;
                        //row.f_je = parseFloat(this.keepTwoDecimal(je));
                    //})
                    //this.$set(data,index,row);
                    //const idx = this.masterSelectedList.findIndex(item => item.i_pzid === row.i_pzid);
                    //if (idx >= 0) this.$set(this.masterSelectedList, idx, { ...row });
                    //this.changeselT()
                    //return
                }
                let je = row.f_je_ws+row.f_je_zzs;
                row.f_je = parseFloat(this.keepTwoDecimal(je));
                //console.log(row.f_je_ws,'row.f_je_ws',cenzzs,'cenzzs',je,'je')
                this.$set(data,index,row);
                const idx = this.masterSelectedList.findIndex(item => item.i_pzid === row.i_pzid);
                if (idx >= 0) this.$set(this.masterSelectedList, idx, { ...row });
                this.changeselT()
            },
            keepTwoDecimal(num) {
                const parsed = parseFloat(num);
                if (isNaN(parsed)) return 0;
                return Number(parsed.toFixed(2));
            },
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })

                this.multipleSelection=[];
                this.currentPage=1;
                this.tableData=[];
                this.changeselT();
                this.getOrders();
            },

            refreshTable(){
                this.showTable=false;
                this.$nextTick(()=>{
                    this.showTable=true;
                    this.restoreSelection()
                })
            },
            restoreSelection() {
                this.$nextTick(() => {
                    this.masterSelectedList.forEach(selectedRow => {
                        const matched = this.tableData.find(item => item.i_pzid === selectedRow.i_pzid);
                        if (matched) {
                            this.$refs.table.toggleRowSelection(matched, true);
                        }
                    });
                });
            },
            select(val,row){
                const isSelected = val.some(item => item.i_pzid === row.i_pzid);
                if(isSelected){
                    const cfcz = this.deletedIds.some(item => item === row.i_id);
                    if(cfcz){
                        row.i_id=0;
                    }
                    //row.f_je=row.f_kglfpje;
                    this.multipleSelection = val;
                    if (!this.masterSelectedList.some(item => item.i_pzid === row.i_pzid)) {
                        this.masterSelectedList.push({ ...row });
                    }
                    //console.log(this.multipleSelection,'val')
                }else{
                    const exists = this.dataList.some(item => item.i_pzid === row.i_pzid);
                    row.f_je=0;
                    if(exists){
                        if(row.i_id!=0){
                            this.deletedIds.push(row.i_id);
                        }
                    }
                    this.multipleSelection = val;
                    this.masterSelectedList = this.masterSelectedList.filter(item => item.i_pzid !== row.i_pzid);
                    //console.log(this.multipleSelection,'val')
                }
                this.changeselT();
            },
            handleSelectionChange(selection) {
                //console.log(selection,'selection')
                if (selection.length === 0) {
                    this.selectedPid = null;
                } else {
                    this.selectedPid = selection[0].i_pz_pid;
                }
            },
            checkSelectable(row, index) {
                if (this.selectedPid === null) return true;
                return row.i_pz_pid === this.selectedPid;
            },
            changeselT(){
                let total=0;
                this.masterSelectedList.forEach(item=>{
                    total += item.f_je
                })
                this.totalje = this.keepTwoDecimal(total);
                //console.log('masterSelectedList',this.masterSelectedList)
            },

            getSummaries({ columns }) {
                //console.log(columns,'columns')
                const sums = [];
                columns.forEach((column, index) => {
                    if (index === 1) {
                        sums[index] = this.$t('invoiceEntry_selected');
                        return;
                    }

                    if ([ 'f_je'].includes(column.property)) {
                        //console.log(this.totalje,'this.totalje')
                        const val = this.totalje || 0;
                        sums[index] = val
                    } else {
                        sums[index] = '';
                    }
                });
                return sums;
            },
            // 查询费用列表
            async getOrders(){
                this.loading=true;
                let param = {
                    'i_mid':this.mid,
                    'i_id':this.dataOrd.i_id,
                    //'i_id':this.dataOrd.i_glfpid,
                    'i_kpkhid':this.dataOrd.i_kpkhid,
                    'i_gsid':this.dataOrd.i_gsid,
                    "currentPage":this.currentPage,
                    "pageSize": this.pageSize,
                    //'vc_fymx':this.dataOrd.vc_fymx,
                    //'dt_startdate':this.dt_startdate,
                    //'dt_enddate':this.dt_enddate,
                    'vc_search':this.vc_search,
                    //'i_checkstate':this.dataOrd.i_checkstate,
                    //'i_kptype':this.dataOrd.i_type,
                    //'i_redInvoiceId':this.dataOrd.i_id,
                    //'isAdd':1,
                    //'inoiceType':2,
                    'i_fpdetailid':this.dataOrd.row.i_id,
               };
                let res = await API.getRebateInvoiceGoods(param);//  fksq
                if (res.code == 1) {
                    this.loading=false;
                    this.tableData = res.data;
                    //this.tableTotal = res.data.total;
                    //console.log(this.tableData);
                    this.$nextTick(() => {
                        const table = this.$refs.table;
                        if (table) {
                            this.tableData.forEach(row => {
                                row.f_je_ws=0;
                                //row.f_sl=0;
                                row.f_sl=this.form.f_sl;
                                row.f_je_zzs=0;
                                /*const isSelected = this.dataZt.select.some(sel => sel.i_pzid == row.i_pzid);
                                const idx = this.dataZt.select.findIndex(sel => sel.i_pzid === row.i_pzid);
                                table.toggleRowSelection(row, isSelected);
                                if(isSelected){
                                    //console.log(isSelected)
                                    row.f_je=this.dataZt.select[idx].f_je
                                    this.multipleSelection.push(row);
                                    console.log(this.multipleSelection,'this.multipleSelection');
                                }*/
                                const isSelected = this.masterSelectedList.some(sel => sel.i_pzid == row.i_pzid);
                                table.toggleRowSelection(row, isSelected);
                                const idx = this.masterSelectedList.findIndex(i => i.i_pzid === row.i_pzid)
                                if (idx !== -1 && isSelected) {
                                    row.f_je=this.masterSelectedList[idx].f_je;
                                    //row.f_sl=this.form.f_sl;
                                    row.f_je_ws=this.masterSelectedList[idx].f_je_ws;
                                    row.f_je_zzs=this.masterSelectedList[idx].f_je_zzs;
                                    this.multipleSelection.push(row);
                                    this.$set(this.masterSelectedList, idx, { ...row, ...this.masterSelectedList[idx] })
                                }
                                const delidx = this.dataZt.del.findIndex(sel => sel === row.i_id);
                                if(delidx!=-1){
                                    row.f_je=0;
                                    row.i_id=0;
                                    row.f_je_ws=0;
                                    row.f_je_zzs=0;
                                }
                            });
                            this.$nextTick(()=>{
                                /*let a_remain=this.dataZt.remain;
                                this.multipleSelection.forEach(row => {
                                    a_remain += Number(row.f_je) || 0;
                                });
                                this.remain=a_remain;
                                //console.log("remain",this.remain);*/
                                this.changeselT()
                            })

                        }
                    });

                    /*let arr = this.dataZt.select;
                    console.log(arr,'arr')
                    this.tableData=this.tableData.filter(itemB => !arr.some(itemA => itemA.i_pzid === itemB.i_pzid));
                    console.log("data",this.tableData)*/
                    this.updateTableHeight();
                    window.addEventListener('resize', this.updateTableHeight);
                } else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getOrders();
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getOrders();
            },

            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getOrders();
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.tableData.map((item,index)=>{
                    this.$refs.table.toggleRowSelection(this.tableData[index],false)
                })
                this.multipleSelection=[];
                this.getOrders();
            },

            deepClone(source) {
                if (typeof source !== 'object' || source == null) {
                    return source;
                }
                const target = Array.isArray(source) ? [] : {};
                for (const key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        if (typeof source[key] === 'object' && source[key] !== null) {
                            target[key] = this.deepClone(source[key]);
                        } else {
                            target[key] = source[key];
                        }
                    }
                }
                return target;
            },
            confirm() {
                const { totalje, remain} = this
                //console.log(totalje,'totalje',remain,'remain')
                let toje =  this.keepTwoDecimal(  totalje );
                let remainje =  this.keepTwoDecimal(  remain );
                const equal = Math.abs(toje) <=  Math.abs(remainje);
                //const equal = this.keepTwoDecimal(  totalje ) <=   this.keepTwoDecimal(remain)
                //console.log(equal,'equal')
                let some0 = this.masterSelectedList.some(item=>item.f_je==0)
                if(some0){
                    this.$message.warning('勾选品种的关联金额不可为0！')
                    return
                }
                if (!equal) {
                    this.$message.warning(this.$t('invoiceEntry_the_currently_selected_tax-inclusive_amount_cannot_exceed_the_remaining_tax-inclusive_amount'))
                    return
                }
                this.$emit('confirmzt', this.masterSelectedList,this.deletedIds)
                //console.log(this.multipleSelection,'this.multipleSelection')

            },
            cancel(){
                this.$emit('confirmzt',[],[]);
            },

        }
    }
</script>
<style>
    .el-message-box__message p{
        max-height: 500px !important;
        overflow-y: auto !important;
    }
</style>
<style  lang="scss" scoped>
    /deep/.el-table td.is-right, .el-table th.is-right {
        text-align: right !important;
    }
    /deep/.el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 0px !important;
    }
    /* 隐藏 el-table 的全选框 */
    /deep/ .el-table__header-wrapper th .cell .el-checkbox {
        display: none;
    }



    /deep/.el-child-table .el-table__body-wrapper{
        width: 100% !important;
    }
    /deep/.el-table__expanded-cell{
        padding: 3px 3px 3px 48px;
    }
    /*.has-child {
        padding: 0px !important;
        // display: none;
        & > .cell {
            padding: 0 !important;
        }
        ::before {
            height: 0;
        }
        .child-table {
            background-color: transparent;
            .cell{
                line-height: 34px;
            }
        }
        .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background-color: transparent;
        }
        .el-table__body tr.current-row > td.el-table__cell,
        .el-table__body tr.selection-row > td.el-table__cell {
            background-color: transparent;
        }
        tr {
            background-color: transparent;
        }
        .child-head {
            display: flex!important;
        }
        /deep/.el-table .el-table__cell{
            padding: 0;
        }
        /deep/.el-table .cell{
            line-height: 34px;
        }
    }*/
    .green{
        color: #67c23a;
    }
    .orange{
        color: #e6a23c;
    }
    .gray{
        color: #909399;
    }
    .red{
        color: #f56c6c !important;
    }

    /deep/.el-table td{
        //text-align: center !important;
    }
    .txtE{
        text-align: end;
    }
    .marl4{
        margin-left: 4px;
    }
    /deep/.red .el-input--mini .el-input__inner{
        color: red !important;
    }
    .red{
        color: red !important;
    }

    /*/deep/.el-table--scrollable-x .el-table__body-wrapper{
        height:195px !important;
    }*/
    .changeinput{
        border: 1px solid #e0e0e0;
        border-radius: 4px;
        width: 90px;
    }
    .el-icon-plus {
        font-size: 20px;
        color: #3e82e8;
        font-weight: bolder;
        background: #eef1f6;
    }

    .popaddbtn{
        border: none;
        padding: 0;
    }
    .pop .addbtn{
        border: none;
        padding: 0;
    }
    .w20{
        width: 20%;
    }
    .blue{
        color: #3e83e8 !important;
    }
    .tw11{
        width: 11%;
    }
    .mart9{
        margin-top: 9px;
    }
    .martb5{
        margin: 9px 0px;
    }
    .txt{
        text-align: center;
    }
    .pad35_25{
        padding: 35px 25px;
    }
    .padB5{
        padding-bottom: 5px;
    }
    .marT10{
        margin-top: 10px;
    }
    .pad15_25{
        padding: 0px 25px;
    }
    .w100{
        width: 100%;
    }
    .w33{
        width: 33%;
    }
    .w50{
        width: 50%;
    }
    .borderB{
        border-bottom: 1px solid #e1e1e1;
    }
    .alc{
        align-items: center;
    }
    .font14_t{
        font-size: 16px;
        color: black;
        min-width:90px;
        font-weight: 500;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:68px;
    }
    .box{
        width: 24px;
        height: 24px;
        line-height: 24px;
    }
    .boxyu{
        //background-color:var(--themeColor);
        background-color: #fa5050;
        border-radius: 4px;
        padding: 1px 4px;
        color: #fff;
        font-size: 14px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }

</style>
